import { render, staticRenderFns } from "./price-edit.vue?vue&type=template&id=12eb9701&scoped=true&"
import script from "./price-edit.vue?vue&type=script&lang=js&"
export * from "./price-edit.vue?vue&type=script&lang=js&"
import style0 from "./price-edit.vue?vue&type=style&index=0&id=12eb9701&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eb9701",
  null
  
)

export default component.exports